// src/components/Header/Header.js
import React, { useContext } from 'react';
import HeaderSignedIn from './HeaderSignedIn';
import HeaderSignedOut from './HeaderSignedOut';
import { AuthContext } from '../../context/AuthContext';

const Header = ({ toggleMenu, menuOpen }) => {
  const { currentUser } = useContext(AuthContext);
  return currentUser ? (
    <HeaderSignedIn 
      onNavMenuTriggerClick={toggleMenu} 
      menuOpen={menuOpen}
      userAvatar={currentUser.avatarUrl}
      userName={currentUser.name}
    />
  ) : (
    <HeaderSignedOut />
  );
};

export default Header;
